<!-- accion-refuerzo-form-modal.component.html -->
<div class="modal-header bg-primary text-white">
  <h5 class="modal-title">
    <i class="icofont icofont-tasks-alt me-1"></i>
    Editar acción de refuerzo
  </h5>
  <button type="button" class="btn-close btn-close-white" (click)="cerrar()"></button>
</div>

<form [formGroup]="form" (ngSubmit)="guardar()" novalidate>
  <div class="modal-body">
    <div class="row g-3">
      <div class="col-md-12">
        <label class="form-label fw-semibold text-dark">
          <i class="icofont icofont-listine-dots me-1"></i>Acción: <span class="text-danger">*</span>
        </label>
        <input type="text" class="form-control" formControlName="accion"
          placeholder="Ej. Reinducción en normas de tránsito">
      </div>

      <div class="col-md-6">
        <label class="form-label fw-semibold text-dark"><i class="icofont icofont-business-man me-1"></i>Responsable:</label>
        <ng-select [items]="colaboradores" bindLabel="nombreCompleto" bindValue="cedula"
          [compareWith]="compararPorCedula" [loading]="cargandoColaboradores" placeholder="Seleccione..."
          formControlName="responsable">
        </ng-select>
      </div>

      <div class="col-md-6">
        <label class="form-label fw-semibold text-dark">
          <i class="icofont icofont-calendar me-1"></i>Fecha compromiso: <span class="text-danger">*</span>
        </label>
        <input type="date" class="form-control" formControlName="fecha_compromiso">
      </div>

      <div class="col-md-6">
        <label class="form-label fw-semibold text-dark">
          <i class="icofont icofont-flag me-1"></i>Estado del plan: <span class="text-danger">*</span>
        </label>
        <ng-select [items]="estadosPlan" bindLabel="descripcion" bindValue="id" [loading]="cargandoEstadosPlan"
          placeholder="Seleccione..." formControlName="estado_plan">
        </ng-select>
      </div>

      <div class="col-md-12">
        <label class="form-label fw-semibold text-dark"><i class="icofont icofont-notepad me-1"></i>Observaciones:</label>
        <textarea class="form-control" rows="3" formControlName="observaciones"></textarea>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="cerrar()" [disabled]="guardando">
      <i class="icofont icofont-close me-1"></i>Cancelar
    </button>
    <button type="submit" class="btn btn-primary" [disabled]="guardando">
      <span *ngIf="!guardando">
        <i class="icofont icofont-save me-1"></i>Actualizar
      </span>
      <span *ngIf="guardando">
        <span class="spinner-border spinner-border-sm me-1"></span>Actualizando...
      </span>
    </button>
  </div>
</form>